export default "__VITE_ASSET__DPYXSKfL__"